<app-header></app-header>
<app-sidebar></app-sidebar>

<div class="content-wrapper" style="min-height: 307px">
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-loader" [fullScreen]="true">
        <p style="color: white"> Loading... </p>
    </ngx-spinner>
    <section id="cut-f">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header bg-secondary">
                    <i class="fas fa-eject"></i>
                    Dashboard แปลงตัดเสร็จ ปี {{year}}
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" (click)="ngOnInit();"><i
                                class="fas fa-sync"></i></button>
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"><i
                                class="fas fa-minus"></i></button>
                    </div>
                </div>

                <div class="card-body">
                    <div class="row justify-content-center">
                        <div class="col-md-auto" style="text-align:center">
                            <mat-form-field appearance="fill">
                                <mat-label>เลือก ส่วน/โซน/นสส</mat-label>
                                <mat-select required [(ngModel)]="data2e" (ngModelChange)="lode_data()">
                                    <mat-option [value]="'&d=1=1'">-รวมทั้งหมด-</mat-option>
                                    <mat-option *ngFor="let dt of data_list[0]"
                                        [value]="'&d=partcode=%27'+dt+'%27'">*ส่วน:[{{dt}}]</mat-option>
                                    <mat-option *ngFor="let dt of data_list[1]"
                                        [value]="'&d=supzone=%27'+dt+'%27'">**โซน:[{{dt}}]</mat-option>
                                    <mat-option *ngFor="let dt of data_list[2]"
                                        [value]="'&d=supcode=%27'+dt+'%27'">**นสส:[{{dt}}]</mat-option>
                                    <mat-option [value]="'d=&1=1'">-รวมทั้งหมด-</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row justify-content-center" *ngIf="data_cutF_sum.length>0">
                        <div class="col-sm-3 card" style="text-align:center">
                            <div id="chart-data_cutFcanetypeSum"
                                style="align-items: center; width: 100%; height:300px;">
                            </div>
                        </div>
                        <div class="col-sm-6 card" style="text-align:center">
                            <div class="small-box bg-warning">
                                <div class="inner">
                                    <h3 style="font-weight: bold;">จำนวนแปลง รวม {{data_cutF_sum[0].cnt_a | number}}
                                        / แปลงตัดเสร็จ {{data_cutF_sum[0].cnt_f | number}}</h3>
                                    <p style="font-weight: bold;">พื้นที่ตัดเสร็จ {{data_cutF_sum[0].landvalue_f|
                                        number}} ไร่
                                        / จากเป้าหมาย {{data_cutF_sum[0].landvalue_a | number}} ไร่
                                        คิดเป็น {{data_cutF_sum[0].pc_area_f}} %</p>
                                    <div class="progress progress-sm">
                                        <div class="progress-bar" [ngStyle]="{'width': data_cutF_sum[0].pc_area_f+'%'}">
                                        </div>
                                    </div>
                                </div>
                                <div class="icon">
                                    <i class=" fas fa-leaf"></i>
                                </div>
                                <a class="small-box-footer">
                                    ตามพื้นที่ปลูก
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="row justify-content-center">
                        <hr>
                        <div class="card-header text-center">
                            <h2> แปลงตัดเสร็จ ตามประเภทอ้อย </h2>
                            <hr>
                        </div>

                        <div class="col-sm-3 card" style="text-align:center">
                            <div id="chart-data_cutFcanetypeER" style="align-items: center; width: 100%; height:300px;">
                            </div>
                        </div>
                        <div class="col-sm-3 card" style="text-align:center">
                            <div id="chart-data_cutFcanetypeSR" style="align-items: center; width: 100%; height:300px;">
                            </div>
                        </div>
                        <div class="col-sm-3 card" style="text-align:center">
                            <div id="chart-data_cutFcanetypeST" style="align-items: center; width: 100%; height:300px;">
                            </div>
                        </div>
                        <div class="col-sm-3 card" style="text-align:center">
                            <div id="chart-data_cutFcanetypeCL" style="align-items: center; width: 100%; height:300px;">
                            </div>
                        </div>
                    </div>


                    <div class="row justify-content-center">
                        <hr>
                        <div class="card-header text-center">
                            <h2> แปลงตัดเสร็จ ตามระดับพื้นที่ </h2>
                            <hr>
                        </div>
                        <div class="col-sm card" style="text-align:center">
                            <div id="chart-data_cutFArealv1" style="align-items: center; width: 100%; height:270px;">
                            </div>
                        </div>
                        <div class="col-sm card" style="text-align:center">
                            <div id="chart-data_cutFArealv2" style="align-items: center; width: 100%; height:270px;">
                            </div>
                        </div>
                        <div class="col-sm card" style="text-align:center">
                            <div id="chart-data_cutFArealv3" style="align-items: center; width: 100%; height:270px;">
                            </div>
                        </div>
                        <div class="col-sm card" style="text-align:center">
                            <div id="chart-data_cutFArealv4" style="align-items: center; width: 100%; height:270px;">
                            </div>
                        </div>
                        <div class="col-sm card" style="text-align:center">
                            <div id="chart-data_cutFArealv5" style="align-items: center; width: 100%; height:270px;">
                            </div>
                        </div>

                    </div>

                    <div class="row justify-content-center">
                        <hr>
                        <div class="card-header text-center">
                            <h2> แปลงตัดเสร็จ ตามประเภทคิว </h2>
                            <hr>
                        </div>
                        <div class="col-sm card" style="text-align:center">
                            <div id="chart-data_cutFQtype3" style="align-items: center; width: 100%; height:300px;">
                            </div>
                        </div>
                        <div class="col-sm card" style="text-align:center">
                            <div id="chart-data_cutFQtype1" style="align-items: center; width: 100%; height:300px;">
                            </div>
                        </div>
                        <div class="col-sm card" style="text-align:center">
                            <div id="chart-data_cutFQtype2" style="align-items: center; width: 100%; height:300px;">
                            </div>
                        </div>
                        <div class="col-sm card" style="text-align:center">
                            <div id="chart-data_cutFQtype4" style="align-items: center; width: 100%; height:300px;">
                            </div>
                        </div>
                    </div>
                    <!--
                    <div class="row justify-content-center" *ngIf="dataArray[2].length>0">
                        <hr>
                        <div class="card-header text-center">
                            <h2> ตามประเภทคิว </h2>
                            <hr>
                        </div>
                        <div class="col-sm card" style="text-align:center" *ngFor="let dt of dataArray[2]">
                            {{dt}}
                            <div id="{{dt}}" style="align-items: center; width: 100%; height:300px;">
                            </div>
                        </div>
                    </div>
                    -->
                </div>
            </div>
        </div>
    </section>
</div>

<app-footer></app-footer>